const Wizard = () => import('./main.vue')

const meta = {
  requiresAuth: true,
}

export default [
  {
    name: 'wizard.index',
    path: '/wizard',
    component: Wizard,
    meta,
  },
]
